import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Alert, Box } from "@mui/material";

const PermissionRoute = ({ permission, element }) => {
  const { websiteUser } = useSelector((state) => state.user);

  // Belum login → redirect ke login
  if (!websiteUser) {
    return <Navigate to="/login" replace />;
  }

  // Cek permission (berlaku untuk semua role, termasuk administrator)
  if (permission && websiteUser.permissions?.includes(permission)) {
    return element;
  }

  // Tidak punya akses → tampilkan peringatan (bukan redirect, agar tidak loop)
  return (
    <Box m="1.5rem 2.5rem">
      <Alert severity="warning">
        Anda tidak memiliki akses ke halaman ini. Hubungi Administrator untuk
        meminta hak akses.
      </Alert>
    </Box>
  );
};

export default PermissionRoute;
